<div class="app-empty-state" [class.app-empty-state-compact]="compact">
  <app-icon [name]="icon" [size]="iconSize" class="app-empty-state-icon"></app-icon>
  <p class="empty-title">{{ title }}</p>
  <p class="empty-desc" *ngIf="description">{{ description }}</p>
  <ng-content></ng-content>
</div>
